export const hasShopAccess = (source) =>
  source?.haveShop === true || source?.haveShop === 1;

export const syncHasShopStorage = (products) => {
  if (!products || Object.keys(products).length === 0) return;
  localStorage.setItem('has_shop', hasShopAccess(products) ? 'true' : 'false');
};

export const syncHasShopFromSalon = (salon) => {
  if (!salon || salon.haveShop === undefined) return;
  localStorage.setItem('has_shop', hasShopAccess(salon) ? 'true' : 'false');
};
